import React from "react";
import "./sideMenu.css";
import SideMenuBtn from "./sideMenuBtn";
import dashboard from "../../images/dashboard.svg";
import student from "../../images/students.svg";
import SideMenuHeader from "./sideMenuHeader";
import { Colors } from "../../Constants/colors";
import { Paths } from "../../Constants/paths";
import { SchoolPricesNavigationHeader } from "../../Constants/Enums/navigationHeader.enum";

const SideMenu = () => {
  return (
    <div
      className="flex flex-col h-full w-full"
      style={{
        backgroundColor: Colors.BurgundyRed,
      }}
    >
      <SideMenuHeader />
      <SideMenuBtn
        title="Dashboard"
        icon={{
          src: dashboard,
          alt: "dashboard",
        }}
        navigateTo={Paths.Dashboard}
      />
      <SideMenuBtn
        title="Student"
        icon={{
          src: student,
          alt: "student",
        }}
        subButtons={[
          {
            name: "All students",
            navigateTo: Paths.StudentList,
          },
          {
            name: "Admission Form",
            navigateTo: Paths.StudentAdmission,
          },
        ]}
      />
      <SideMenuBtn
        title="Teacher"
        icon={{
          src: student,
          alt: "student",
        }}
        subButtons={[
          {
            name: "All teachers",
            navigateTo: Paths.TeachersList,
          },
          {
            name: "Register teacher",
            navigateTo: Paths.RegisterTeachers,
          },
        ]}
      />
      <SideMenuBtn
        title="Parents"
        icon={{
          src: student,
          alt: "parents",
        }}
        subButtons={[
          {
            name: "All Parents",
            navigateTo: Paths.ParentsList,
          },
          {
            name: "Register Parent",
            navigateTo: Paths.RegisterParent,
          },
        ]}
      />

      <SideMenuBtn
        title="Subject"
        icon={{
          src: student,
          alt: "subject",
        }}
        navigateTo={Paths.Subject}
      />

      <SideMenuBtn
        title="Classes"
        icon={{
          src: student,
          alt: "class",
        }}
        navigateTo={Paths.Class}
      />

      <SideMenuBtn
        title="Results"
        icon={{
          src: student,
          alt: "results",
        }}
        subButtons={[
          {
            name: "Add result",
            navigateTo: Paths.AddResult,
          },
          {
            name: "Register Parent",
            navigateTo: Paths.RegisterParent,
          },
        ]}
      />

      <SideMenuBtn
        title="Branches"
        icon={{
          src: student,
          alt: "subject",
        }}
        navigateTo={Paths.Branch}
      />

      <SideMenuBtn
        title="Blocks"
        icon={{
          src: student,
          alt: "subject",
        }}
        navigateTo={Paths.Block}
      />

      <SideMenuBtn
        title="Transport"
        icon={{
          src: student,
          alt: "transport",
        }}
        navigateTo={Paths.Transport}
      />

      <SideMenuBtn
        title="Notification"
        icon={{
          src: student,
          alt: "notification",
        }}
        navigateTo={Paths.Notification}
      />

      <SideMenuBtn
        title="School prices"
        icon={{
          src: student,
          alt: "school prices",
        }}
        navigateTo={`${Paths.SchoolPrices}?section=${SchoolPricesNavigationHeader.ACADEMIC_PRICE}`}
      />
    </div>
  );
};
export default SideMenu;
